import { Col, message, PageHeader, Row, Spin, Select, Space, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  ButtonItem,
  ErrorItem,
  SelectInsumosItem,
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import reportePedidosPendientesApartarPdf from "../../../../Pdf/reportePedidosPendientesApartarPdf";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReportePedidosPendientesApartar extends Component {
  state = {
    loading: false,
    objetoClientes: null,
    objetoUsuarios: null,
    objetoProyectos: null,
    objetoUniadesDeNegocio: null,
    dataReporte: null,
    todasPedidos: [],
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoClientes: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.stringBuscar}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoUsuarios: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " " + value.apellidoPaterno + " " + value.apellidoMaterno}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5
                ) +
                  " - " +
                  value.nombre}
              </Option>
            )),
          });
        }
      });
    this.consultar({ filtrarProyecto: 0 });
  }

  consultar(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reporteInsumosPendientes/reportePedidosPendientesApartar",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasPedidos: res.data.data,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      });
  }

  descargarExcel() {
    const datosDescargar = this.state.todasPedidos.map((value) => ({
      Folio: value.folio,
      Fecha: value.fecha,
      Cliente: value.cliente,
      Vendedor: value.vendedor,
      Proyecto: value.proyecto,
      "Clave Insumo": value.claveInsumo,
      Descripcion: value.descripcionInsumo,
      Cantidad: value.cantidad,
      Vendido: value.vendido,
      Apartado: value.apartado,
      "Pendiente Apartar": value.pendiente,
      Estado: value.estado,
      "Inventario Disponible": value.inventarioDisponible,
      "OC Pendiente": value.ocPendiente,
      "Falta Pedir": value.faltantePedir,
    }));
    const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pedidos Pendientes De Apartar");
    XLSX.writeFile(
      workbook,
      `Pedidos_Pendientes_De_Apartar_${moment().locale("es").format("L")}.xlsx`
    );
  }

  descargarPdf() {
    pdfMake
      .createPdf(reportePedidosPendientesApartarPdf(this.state.dataReporte))
      .download(`Pedidos_Pendientes_De_Apartar_${moment().locale("es").format("L")}`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      { title: "Folio", dataIndex: "folio", key: "folio", buscar: "folio", ellipsis: true, sorter: (a, b) => (a.folio < b.folio ? -1 : a.folio > b.folio ? 1 : 0) },
      { title: "Fecha", dataIndex: "fecha", key: "fecha", buscar: "fecha", ellipsis: true, sorter: (a, b) => (moment(a.fecha, "DD/MM/YYYY") < moment(b.fecha, "DD/MM/YYYY") ? -1 : 1) },
      { title: "Cliente", dataIndex: "cliente", key: "cliente", buscar: "cliente", ellipsis: true, sorter: (a, b) => (a.cliente < b.cliente ? -1 : a.cliente > b.cliente ? 1 : 0) },
      { title: "Vendedor", dataIndex: "vendedor", key: "vendedor", buscar: "vendedor", ellipsis: true, sorter: (a, b) => (a.vendedor < b.vendedor ? -1 : a.vendedor > b.vendedor ? 1 : 0) },
      { title: "Proyecto", dataIndex: "proyecto", key: "proyecto", buscar: "proyecto", ellipsis: true, sorter: (a, b) => (a.proyecto < b.proyecto ? -1 : a.proyecto > b.proyecto ? 1 : 0) },
      { title: "Clave", dataIndex: "claveInsumo", key: "claveInsumo", buscar: "claveInsumo", ellipsis: true, sorter: (a, b) => (a.claveInsumo < b.claveInsumo ? -1 : a.claveInsumo > b.claveInsumo ? 1 : 0) },
      { title: "Descripción", dataIndex: "descripcionInsumo", key: "descripcionInsumo", buscar: "descripcionInsumo", ellipsis: true, sorter: (a, b) => (a.descripcionInsumo < b.descripcionInsumo ? -1 : a.descripcionInsumo > b.descripcionInsumo ? 1 : 0) },
      { title: "Cantidad", dataIndex: "cantidad", key: "cantidad", align: "right", ellipsis: true, sorter: (a, b) => a.cantidad - b.cantidad },
      { title: "Vendido", dataIndex: "vendido", key: "vendido", align: "right", ellipsis: true, sorter: (a, b) => a.vendido - b.vendido },
      { title: "Apartado", dataIndex: "apartado", key: "apartado", align: "right", ellipsis: true, sorter: (a, b) => a.apartado - b.apartado },
      { title: "Pendiente Apartar", dataIndex: "pendiente", key: "pendiente", align: "right", ellipsis: true, sorter: (a, b) => a.pendiente - b.pendiente },
      { title: "Estado", dataIndex: "estado", key: "estado", buscar: "estado", ellipsis: true, sorter: (a, b) => (a.estado < b.estado ? -1 : a.estado > b.estado ? 1 : 0) },
      { title: "Inventario Disponible", dataIndex: "inventarioDisponible", key: "inventarioDisponible", align: "right", ellipsis: true, sorter: (a, b) => a.inventarioDisponible - b.inventarioDisponible },
      { title: "OC Pendiente", dataIndex: "ocPendiente", key: "ocPendiente", ellipsis: true },
      { title: "Falta Pedir", dataIndex: "faltantePedir", key: "faltantePedir", align: "right", ellipsis: true, sorter: (a, b) => a.faltantePedir - b.faltantePedir },
    ];
    return (
      <>
        <Form
          name="reportePedidosPendientesApartar"
          onFinish={this.consultar.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{ filtrarProyecto: 0 }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Pedidos Pendientes De Apartar"
            style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem blanco onClick={() => this.descargarExcel()} icon={<FileExcelOutlined />}>
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem blanco onClick={() => this.descargarPdf()} icon={<FilePdfOutlined />}>
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem type="primary" htmlType="submit">
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5, borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <Tabs style={{ margin: 0 }} tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}>
                <TabPane tabKey="1" key="1" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Clientes">
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Vendedores">
                  <FormItem name="vendedores" margin noStyle>
                    <SelectItem width="90%" mode="multiple" placeholder="Vendedores">
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>Niguno</Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto = getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem width="90%" placeholder="Proyectos" mode="multiple">
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem width="90%" placeholder="Unidades de Negocio">
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Insumos">
                  <FormItem name="insumos" margin noStyle>
                    <SelectInsumosItem
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      mode="multiple"
                      width="90%"
                      placeholder="Insumo"
                      tiposInsumos="inventariables"
                    />
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>
            <TableItem
              onRow={(record) => ({
                onDoubleClick: () => {
                  this.props.history.push("/panel/verPedido", { id: record.pedidoId });
                },
              })}
              rowKey={(value) => value.rowKey}
              columns={columns}
              dataSource={this.state.todasPedidos}
              size="small"
              pagination={false}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReportePedidosPendientesApartar);
